/* import __COLOCATED_TEMPLATE__ from './bracket-config-editor.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class BracketConfigEditorComponent extends Component
{
	@tracked brackets = [];

	constructor()
	{
		super(...arguments);
		// Deep clone the initial config (array of brackets)
		this.brackets = JSON.parse(JSON.stringify(this.args.config || []));
	}

	@action addBracket()
	{
		this.brackets = [...this.brackets, {
			name: 'new-bracket',
			results: [],
			config: [[]]
		}];
	}

	@action removeBracket(bracketIndex)
	{
		this.brackets = this.brackets.filter((_, i) => i !== bracketIndex);
	}

	@action updateBracket(bracketIndex, updatedBracket)
	{
		const newBrackets = [...this.brackets];
		newBrackets[bracketIndex] = updatedBracket;
		this.brackets = newBrackets;
	}

	@action downloadConfig()
	{
		const jsonString = JSON.stringify(this.brackets, null, 2);
		const blob = new Blob([jsonString], { type: 'application/json' });
		const url = URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = 'bracketConfig.json';
		a.click();
		URL.revokeObjectURL(url);
	}
}
